/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyersstyle2Inputs */

const en_placeflyersstyle2 = /** @type {(inputs: Placeflyersstyle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style`)
};

const de_placeflyersstyle2 = /** @type {(inputs: Placeflyersstyle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stil`)
};

/**
* | output |
* | --- |
* | "Style" |
*
* @param {Placeflyersstyle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyersstyle2 = /** @type {((inputs?: Placeflyersstyle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyersstyle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyersstyle2(inputs)
	return de_placeflyersstyle2(inputs)
});
export { placeflyersstyle2 as "placeFlyersStyle" }